import { useState } from "react";
import { Button } from "./base/Button"
import { Input } from "./base/Input"
import { handleApiError } from "utils/errorHandlers";
import { ApiError } from "./ApiError";
import {forgotPassword} from "services/apiAuth";

export const MDPOublieContent = () => {
  const [email, setEmail] = useState<string>("");
  const [success, setSuccess] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [errors, setErrors] = useState<Record<string, string[]>>({});

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
		setErrors({});
    setLoading(true);
    try {
      const response = await forgotPassword(email);
      if (response.status === 200) {
        setSuccess(true);
      }
    } catch (error) {
      setErrors(handleApiError(error));
    } finally {
      setLoading(false);
    }
  }

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-6">
      <Input
        label="Email"
        name="email"
        type="email"
        width="100%"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        error={errors.email && errors.email[0]}
      />

      {errors.general && (
        <ApiError>{errors.general[0]}</ApiError>
      )}

      {success && (
        <div className="bg-info-100 border border-info-400 rounded px-3 py-2">
          Vous avez reçu un email avec un lien de réinitialisation de mot de passe.
        </div>
      )}

      <div className="flex justify-center">
        <Button type="submit" disabled={loading}>{loading ? 'Veuillez patienter...' : 'Réinitialiser le mot de passe'}</Button>
      </div>

    </form>
  )
}